/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/no-distracting-elements */
import * as HERBUI from "react-bootstrap";
import "../loginandlandingpage.css";
import * as Yup from 'yup';
import { ErrorMessage, Field, FormikProvider, useFormik } from 'formik';
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { LOGIN_DOMAIN, AUTHENTICATION_URL, USER_VERIFICATION_OTP, LOGIN_CHECK, LOGIN_AUTHENTICATION_URL_TOTP } from "../Api/APIURLS";
import { useDispatch } from "react-redux";
import { CommonAjaxPostLoginRequest } from '../Api/CommonAjaxUtils'
import { FaEye, FaEyeSlash, FaInfoCircle } from "react-icons/fa";
import { allowNumbersOnly, origins } from "../components/Functions";
import login_popup from "../images/TOTP.png";
import close from '../images/close.png';
import Swal from "sweetalert2";
var createHost = require('cross-domain-storage/host');
var createGuest = require('cross-domain-storage/guest');
const LoginPageDev = () => {
    var storageHost = null;
    var mainAppguest = null;
    const [errorMsg, setErrorMsg] = useState('')
    const [otpStatus, setOtpStatus] = useState('')
    const [showFields, setShowFields] = useState(false)
    const dispatch = useDispatch();
    const history = useHistory();
    const [showErrorMsg, setShowErrorMsg] = useState(false);
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const [apgliPressNoteShow, setApgliPressNoteShow] = useState(true)
    const handleCloseApgliPressNote = () => setApgliPressNoteShow(false)
    const intialValues = {
        username: '', password: '', otp: "", name: "", mobileNo: "",
        email: "", uid: "", trn: "", OTpValidation: '', aadhaarType: '', showPassword: false
    }
    const [buttonType, setButtonType] = useState("")
    const [disableUsername, setDisableUserName] = useState(false)
    const [passwordType, setPasswordType] = useState("password");
    const [msg, setMsg] = useState("")
    const [passwordValidation, setPasswordValidation] = useState(false)
    const validationSchema = Yup.object({
        username: Yup.string().required('Required'),
    })
    const otpPasswordValidation = Yup.object({
        aadhaarType: Yup.string().required("Required"),
        otp: Yup.string().required("Required"),
        password: Yup.string().required("Required"),

    })
    const UserPasswordValidation = Yup.object({
        username: Yup.string().required('Required'),
        password: Yup.string().required("Required")
    })

    useEffect(() => {
        localStorage.removeItem('passwordExpiry')
        storageHost = createHost(
            origins.map(origin => ({ origin, allowedMethods: ['get', 'set', 'remove'] }))
        );

        localStorage.removeItem('loginFailErrorMsg')
    }, [])
    const formik = useFormik({
        initialValues: intialValues,
        validationSchema: buttonType === "SignIn" ? (passwordValidation === false ? UserPasswordValidation : otpPasswordValidation) : validationSchema,
        onSubmit: (values) => {
            if (buttonType === "go") {
                let params = { "userId": values.username }
                setShowFields(true)
                setDisableUserName(true)
                // CommonAjaxGetRequestWithOutParamsWithOutAuthorization(USER_VERIFICATION + values.username).then((res) => {
                // CommonAjaxPostLoginRequest(USER_VERIFICATION_OTP, params).then((res) => {
                //     if (res.SCODE === "01") {
                //         setOtpStatus('sent')
                //         setShowFields(true)
                //         setShowErrorMsg(false)
                //         setDisableUserName(true)
                //         setMsg(res.SDESC)
                //         formik.setFieldValue("uid", res.uid)
                //         formik.setFieldValue("trn", res.trn)
                //         formik.setFieldValue("OTpValidation", res.optValidation)
                //     }
                //     else if (res.SCODE === "02") {
                //         setOtpStatus('')
                //         setShowFields(false)
                //         setShowErrorMsg(true)
                //         setErrorMsg(res.SDESC)
                //         setDisableUserName(false)
                //     }
                // })
                CommonAjaxPostLoginRequest(LOGIN_CHECK, params).then((res) => {
                    if (res && res.SCODE === "01") {
                        // setOtpStatus('sent')
                        // setShowFields(true)
                        // setShowErrorMsg(false)
                        // setDisableUserName(true)
                        // setMsg(res.SDESC)
                        // formik.setFieldValue("uid", res.uid)
                        // formik.setFieldValue("trn", res.trn)
                        formik.setFieldValue("OTpValidation", "0")
                        formik.setFieldValue("showPassword", true)
                    }
                    else if (res && res.SCODE === "02") {
                        // setOtpStatus('')
                        // setShowFields(false)
                        // setShowErrorMsg(true)
                        // setErrorMsg(res.SDESC)
                        // setDisableUserName(false)
                        formik.setFieldValue("OTpValidation", "1")
                    }
                })
            }
            else if (buttonType === "SignIn") {
                localStorage.removeItem("token");
                localStorage.removeItem("serviceList");
                // localStorage.clear();
                localStorage.setItem('userId', values.username)
                localStorage.setItem('userName', JSON.stringify(values.username))
                let params = {}
                if (String(values.OTpValidation) === "0") {
                    values.username = values.username.trim()
                    values.password = values.password.trim()
                    params = { username: values.username, password: values.password }
                    CommonAjaxPostLoginRequest(AUTHENTICATION_URL, values, dispatch, history).then((response) => {
                        if (response !== "" && response !== null && response !== undefined) {
                            localStorage.setItem("token", JSON.stringify(response.access_token));
                            localStorage.setItem("refresh_token", JSON.stringify(response.refresh_token));
                            localStorage.setItem('userData', JSON.stringify(response))
                            localStorage.setItem('userName', JSON.stringify(values.username))
                            localStorage.setItem('reloaded', 'false')
                            if (response?.message) {
                                localStorage.setItem("expirationErrorMsg", JSON.stringify(response?.message))
                            }
                            mainAppguest = createGuest(LOGIN_DOMAIN);
                            let displayName = ""
                            const base64Url = response?.access_token.split('.')[1];
                            if (base64Url !== undefined) {
                                const base64 = base64Url.replace('-', '+').replace('_', '/');
                                displayName = JSON.parse(window.atob(base64)).name
                                localStorage.setItem('displayName', JSON.stringify(displayName))
                            }
                            mainAppguest.set('token', JSON.stringify(response.access_token), function (error, data) {
                                // foo is now set to 'bar'
                            });
                            mainAppguest.set('displayName', JSON.stringify(displayName), function (error, data) {
                                // foo is now set to 'bar'
                            });
                            mainAppguest.set('userData', JSON.stringify(response), function (error, data) {
                                // foo is now set to 'bar'
                            });
                            mainAppguest.set('refresh_token', JSON.stringify(response.refresh_token), function (error, data) {
                                // foo is now set to 'bar'
                            });
                            mainAppguest.set('userId', JSON.stringify(values.username), function (error, data) {
                                // foo is now set to 'bar'
                            });
                            history.push("/dashboard");
                        }
                        else {
                            dispatch({ type: 'HIDE_SPINNER', payload: { key: 'showSpinner', value: false } });
                            setShowErrorMsg(true);
                            // setErrorMsg("Invalid Username or Password")
                            setErrorMsg(localStorage.getItem('loginFailErrorMsg'))
                            formik.setFieldValue('username', '');
                            formik.setFieldValue('password', '');
                            formik.setFieldValue('otp', '');
                            setDisableUserName(false)
                            setShowFields(false)
                            setOtpStatus('go')
                        }
                    });
                }
                else if (String(values.OTpValidation) === "1") {
                    localStorage.setItem('userName', JSON.stringify(values.username))
                    if (values.aadhaarType === "1") {
                        params = {
                            "uid": values.uid, "otp": values.otp, "trn": values.trn, "userId": values.username.trim(),
                            "password": values.password.trim(), "otpFlag": values.aadhaarType
                        }
                    }
                    else if (values.aadhaarType === "2") {
                        params = {
                            "uid": values.uid, "otp": values.otp, "trn": values.trn, "userId": values.username.trim(),
                            "password": values.password.trim(), "otpFlag": values.aadhaarType
                            // "otp": values.otp,
                            // "userId": values.username.trim(),
                            // "password": values.password.trim(),
                            // "otpFlag": values.aadhaarType
                        }
                    }
                    // CommonAjaxPostLoginRequest(LOGIN_AUTHENTICATION_URL, params, dispatch).then((response) => { In Local 
                    CommonAjaxPostLoginRequest(LOGIN_AUTHENTICATION_URL_TOTP, params, dispatch).then((response) => {
                        if (response.SCODE === "01") {
                            let responseData = response.token?.body
                            // if (response !== "" && response !== null && response !== undefined) {
                            localStorage.setItem("token", JSON.stringify(responseData.access_token));
                            localStorage.setItem("refresh_token", JSON.stringify(responseData.refresh_token));
                            localStorage.setItem('userData', JSON.stringify(responseData))
                            localStorage.setItem('userName', JSON.stringify(values.username))
                            if (responseData?.message) {
                                localStorage.setItem("expirationErrorMsg", JSON.stringify(responseData?.message))
                            }
                            if (responseData?.passwordExpiry === true) {
                                debugger;
                                localStorage.setItem("passwordExpiry", JSON.stringify(responseData?.passwordExpiry))
                                Swal.fire({ text: responseData?.message, icon: 'error', allowEnterKey: false, allowEscapeKey: false, allowOutsideClick: false }).then(function (isConfirm) {
                                    if (isConfirm.value) {
                                        history.push({ pathname: '/forgotPassword', state: 'passwordExpired' })
                                    }
                                })
                            }
                            else {
                                mainAppguest = createGuest(LOGIN_DOMAIN);
                                let displayName = ""
                                const base64Url = responseData?.access_token.split('.')[1];
                                if (base64Url !== undefined) {
                                    const base64 = base64Url.replace('-', '+').replace('_', '/');
                                    displayName = JSON.parse(window.atob(base64)).name
                                    localStorage.setItem('displayName', JSON.stringify(displayName))

                                }

                                mainAppguest.set('token', JSON.stringify(responseData.access_token), function (error, data) {
                                    // foo is now set to 'bar'
                                });
                                mainAppguest.set('displayName', JSON.stringify(displayName), function (error, data) {
                                    // foo is now set to 'bar'
                                });
                                mainAppguest.set('userData', JSON.stringify(responseData), function (error, data) {
                                    // foo is now set to 'bar'
                                });
                                mainAppguest.set('refresh_token', JSON.stringify(responseData.refresh_token), function (error, data) {
                                    // foo is now set to 'bar'  
                                });
                                mainAppguest.set('userId', JSON.stringify(values.username), function (error, data) {
                                    // foo is now set to 'bar'  
                                });
                                history.push("/dashboard");
                            }
                        }
                        else if (response.SCODE === "02") {
                            setErrorMsg(response.SDESC)
                            dispatch({ type: 'HIDE_SPINNER', payload: { key: 'showSpinner', value: false } });
                            setShowErrorMsg(true);
                            formik.setFieldValue('username', '');
                            formik.setFieldValue('password', '');
                            formik.setFieldValue('otp', '');
                            setDisableUserName(false)
                            setShowFields(false)
                            setOtpStatus('go')
                            formik.resetForm()
                        }
                    }).catch(() => setTimeout(() => {/* call component loader again !! */ }, 1500));
                }

            }
        }
    });
    function getAadharOTPByLoginId(params) {
        CommonAjaxPostLoginRequest(USER_VERIFICATION_OTP, params).then((res) => {
            if (res.SCODE === "01") {
                setOtpStatus('sent')
                setShowFields(true)
                setShowErrorMsg(false)
                setDisableUserName(true)
                setMsg(res.SDESC)
                formik.setFieldValue("uid", res.uid)
                formik.setFieldValue("trn", res.trn)
                formik.setFieldValue("OTpValidation", res.optValidation)
            }
            else if (res.SCODE === "02") {
                setOtpStatus('')
                setShowFields(false)
                setShowErrorMsg(true)
                setErrorMsg(res.SDESC)
                setDisableUserName(false)
                formik.setFieldValue("uid", "")
                formik.setFieldValue("trn", "")
                formik.setFieldValue("OTpValidation", "")
            }
        })
    }
    useEffect(() => {
        if (String(formik.values.OTpValidation) === "0") {
            setPasswordValidation(false)
        }
        else if (String(formik.values.OTpValidation) === "1") {
            setPasswordValidation(true)
        }
    }, [formik.values.OTpValidation])
    function knowYourChallan() {
        history.push('/knowYourCfmsId')
    }
    function forgotPassword() {
        history.push("/forgotPassword");
    }
    function gotoServiceAssociationPage() {
        history.push("/serviceassociation");
    }
    function gos() {
        history.push("/gos");
    }
    function newAlerts() {
        history.push("/budgetRelatedPdfDetails");
    }

    const togglePassword = () => {
        if (passwordType === "password") {
            setPasswordType("text")
            return;
        }
        setPasswordType("password")
    }
    const apfrsMobileApp = () => {
        history.push("/mobileApp")
    }
    function userIdonChange(e) {
        // let userId = e.target.value
        localStorage.clear();
        formik.handleChange(e)
        let targetValue = (e.target.value + " ").trim()
        formik.setFieldValue("username", targetValue)

        // let params = { "userId": userId }
        // if (userId !== '' && (userId.length === 8 || userId.length === 10)) {
        //     CommonAjaxPostLoginRequest(LOGIN_CHECK, params).then((res) => {
        //         if (res && res.SCODE === "01") {
        //             // setOtpStatus('sent')
        //             // setShowFields(true)
        //             // setShowErrorMsg(false)
        //             // setDisableUserName(true)
        //             // setMsg(res.SDESC)
        //             // formik.setFieldValue("uid", res.uid)
        //             // formik.setFieldValue("trn", res.trn)
        //             formik.setFieldValue("OTpValidation", "0")
        //             formik.setFieldValue("showPassword", true)
        //         }
        //         else if (res && res.SCODE === "02") {
        //             // setOtpStatus('')
        //             // setShowFields(false)
        //             // setShowErrorMsg(true)
        //             // setErrorMsg(res.SDESC)
        //             // setDisableUserName(false)
        //             formik.setFieldValue("OTpValidation", "1")
        //         }
        //     })
        // }
    }
    function RadioButtonOnChange(e) {
        let targetvalue = e.target.value
        let params = { "userId": formik.values.username }
        formik.setFieldValue("aadhaarType", targetvalue)
        if (targetvalue === "1" && formik.values.username !== '') {
            getAadharOTPByLoginId(params)
        }
        else if (targetvalue === "2" && formik.values.username !== '') {
            // getAadharOTPByLoginId(params)
            // call api for Aadhar Totp
        }
    }
    return (
        <>
            <FormikProvider value={formik}>
                <HERBUI.Navbar collapseOnSelect expand="lg" className="HERB-Top-Nav" variant="dark">
                    <HERBUI.Container fluid>
                        <HERBUI.Navbar.Brand href="/login">
                            <img
                                src="img/herb.svg"
                                width="250"
                                height="45"
                                className="d-inline-block align-top"
                                alt="NIDHI"
                            />
                        </HERBUI.Navbar.Brand>
                        <HERBUI.Navbar.Toggle className="bg-secondary" aria-controls="responsive-navbar-nav" style={{ marginRight: '30px' }} />
                        <HERBUI.Navbar.Collapse id="responsive-navbar-nav">
                            <HERBUI.Nav className="me-auto"></HERBUI.Nav>
                            <HERBUI.Nav>
                                <HERBUI.Nav.Link href={'https://epts.ap.gov.in/opts/login.html'} target="_blank" rel="noreferrer" className="nav_link1">
                                    <b>HR Mapping<img src="../img/gif_new.gif" alt="new" /></b>
                                </HERBUI.Nav.Link>
                                <HERBUI.Nav.Link onClick={() => gotoServiceAssociationPage()} className="nav_link1">
                                    <b  >Service Association</b>
                                </HERBUI.Nav.Link>&nbsp;&nbsp;&nbsp;&nbsp;
                                <HERBUI.Nav.Link onClick={() => knowYourChallan()} className="nav_link1">
                                    <b  >Know Your CFMS ID</b>
                                </HERBUI.Nav.Link>&nbsp;&nbsp;&nbsp;&nbsp;
                                <HERBUI.Nav.Link onClick={() => gos()} className="nav_link1">
                                    <b  >GOs, Circulars, Memos</b>
                                </HERBUI.Nav.Link>
                                <HERBUI.Nav.Link onClick={() => newAlerts()} className="nav_link1">
                                    {/* <b>Budget 2023-24</b> */}
                                    {/* <b>Budget 2024-25<img src="../img/gif_new.gif" alt="new" /></b> */}
                                    <b>Budget 2025-26</b>
                                </HERBUI.Nav.Link>
                                <HERBUI.Nav.Link href={'https://appstore.nidhi.apcfss.in/iOSHerb.html'} target="_blank" rel="noreferrer" className="nav_link1">
                                    <b>Download Employee Mobile APP (NIDHI)</b>
                                </HERBUI.Nav.Link>
                                <HERBUI.Nav.Link className="nav_link1" onClick={() => apfrsMobileApp()}>
                                    <b>APFRS Mobile APP</b>
                                </HERBUI.Nav.Link>
                            </HERBUI.Nav>
                        </HERBUI.Navbar.Collapse>
                    </HERBUI.Container>
                </HERBUI.Navbar>
                <HERBUI.Navbar collapseOnSelect expand="lg" variant="dark">
                    <HERBUI.Container style={{ marginLeft: '0px' }}>
                    </HERBUI.Container>
                </HERBUI.Navbar>
                {/* <HERBUI.Row>
                    <HERBUI.Col>
                        <span style={{ color: 'red', fontSize: '15px' }}>
                            Scheduled Maintenance Alert:<span className="text-danger">*</span></span>
                        <span style={{ color: 'black', fontSize: '15px' }}>The Nidhi Portal will be temporarily unavailable from 13/01/2025, 11:59 PM to 14/01/2025,
                            11:59 PM for a database upgrade activity.
                        </span>

                    </HERBUI.Col>
                </HERBUI.Row> */}
                <HERBUI.Row style={{ marginBottom: '50px' }}>
                    <HERBUI.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} />
                    <HERBUI.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className="  " >
                        <img src="img/corner.svg" className="corner" alt="dots" />
                        <div className="main_form" autoComplete="off">
                            <HERBUI.Container>
                                <HERBUI.Row>
                                </HERBUI.Row>
                            </HERBUI.Container>
                            <form className="form_adjust" onSubmit={formik.handleSubmit}>
                                <div className="inner-herbpage-service-title-sub-np">
                                    <h1 style={{ fontSize: '22px' }}> Login </h1>
                                </div>
                                <HERBUI.InputGroup className="mb-3 form-floating">
                                    <Field name="username" placeholder="User ID" id="ids" type="text" aria-label="User ID" aria-describedby="basic-addon1"
                                        onChange={userIdonChange} maxLength={15}
                                        className="form-control rounded" readOnly={disableUsername} autoComplete="new-username" />
                                    <label htmlFor="ids">User ID</label>

                                    {showFields === false && <button type="submit" className="btn btn-success rounded ms-2" onClick={() => setButtonType("go")}>Go</button>}

                                    <ErrorMessage name="username" className="text-error" component="div" />
                                </HERBUI.InputGroup>

                                {showFields &&
                                    <>
                                        {(String(formik.values.OTpValidation) === "1" || formik.values.OTpValidation === "") &&
                                            <>
                                                <HERBUI.InputGroup className="mb-3 form-floating">
                                                    <Field type="radio" name="aadhaarType" id="aadhaarOTP" value="1" checked={formik.values?.aadhaarType === "1"}
                                                        onChange={(e) => {
                                                            RadioButtonOnChange(e)
                                                        }}
                                                    /> &nbsp;Aadhaar OTP &emsp;
                                                    <Field type="radio" name="aadhaarType" id="aadhaarTotp" value="2" checked={formik.values?.aadhaarType === "2"}
                                                        onChange={(e) => {
                                                            RadioButtonOnChange(e)
                                                        }}
                                                    /> &nbsp; Time-based OTP
                                                    {/* <label htmlFor="otp"></label> */}
                                                    <ErrorMessage className="text-error" name="aadhaarType" component={"div"} />
                                                </HERBUI.InputGroup>
                                                {
                                                    // String(formik.values.OTpValidation) === "1" &&
                                                    String(formik.values.aadhaarType) !== "" &&
                                                    <div className='alert alert-info'>
                                                        <span className='mb-1'>{String(formik.values.aadhaarType) === "1" ? msg :
                                                            <> Enter TOTP visible on Your NIDHI App <span style={{ textAlign: 'right' }}><FaInfoCircle style={{ height: '15px', width: '15px' }} onClick={() => { setShow(true) }} /></span> </>}
                                                        </span>
                                                        &nbsp;&nbsp;
                                                    </div>
                                                }
                                                <HERBUI.InputGroup className="mb-3 form-floating" >
                                                    <Field placeholder="Enter OTP" name="otp" type="text" aria-label="OTP" maxLength={6} readOnly={formik.values.aadhaarType === ""}
                                                        aria-describedby="basic-addon1" className="form-control" autoComplete="off" onKeyPress={allowNumbersOnly}
                                                        onChange={(e) => {
                                                            formik.setFieldValue('otp', e.target.value)
                                                        }}
                                                    />
                                                    <label htmlFor="otp">{formik.values.aadhaarType === "2" ? "TOTP" : "OTP"}</label>
                                                    <ErrorMessage className="text-error" name="otp" component={"div"} />
                                                </HERBUI.InputGroup>
                                            </>
                                        }
                                        {/* {otpStatus === 'sent' && */}
                                        {(formik.values.showPassword === true || formik.values.OTpValidation !== "") &&
                                            <HERBUI.InputGroup className="mb-3 form-floating" >
                                                {/* <Field placeholder="Enter Password" name="password" type={passwordType} aria-label="Password" aria-describedby="basic-addon1"
                                                    className="form-control rounded" autoComplete="off" id="passwords"
                                                    onChange={(e) => {
                                                        formik.setFieldValue('password', e.target.value)
                                                    }}
                                                /> */}
                                                <input placeholder="Password" name="password" type={passwordType} id="password"
                                                    aria-label="Password"
                                                    aria-describedby="basic-addon1" value={formik.values.password}
                                                    className="form-control rounded"
                                                    // onChange={(e) => {
                                                    //     formik.setFieldValue('password', e.target.value)
                                                    // }} 
                                                    onChange={(e) => {
                                                        formik.setFieldValue("password", (e.target.value + "").trim())
                                                        document.getElementById("password").value = (e.target.value + "").trim()
                                                    }} autoComplete="new-password"
                                                />
                                                <label htmlFor="passwords">Password</label>
                                                <HERBUI.InputGroup.Text id="basic-addon2 " className="basic-addon2">
                                                    {passwordType === "password" ? <FaEyeSlash onClick={togglePassword} /> : <FaEye onClick={togglePassword} />}
                                                </HERBUI.InputGroup.Text>
                                                <ErrorMessage className="text-error" name="password" component={"div"} />
                                            </HERBUI.InputGroup>
                                        }

                                        {/* } */}
                                    </>
                                }

                                <div className="d-grid gap-2">
                                    {/* {otpStatus === 'sent' && */}
                                    {formik.values.OTpValidation !== "" &&
                                        <HERBUI.Button variant="primary" type="submit" className="btn_success signin-bg rounded" onClick={() => setButtonType("SignIn")}>
                                            Sign in
                                        </HERBUI.Button>
                                    }
                                    {/* } */}
                                    <a className="text-center forgot mb-4" style={{ zIndex: "9994" }}
                                        onClick={() => forgotPassword()} onKeyDown={(e) => {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                forgotPassword()
                                            }
                                        }}>Forgot Password ?</a>
                                    <div
                                        style={{
                                            marginTop: "15px",
                                            padding: "12px 15px",
                                            background: "#FCE4EC",       // Light magenta/pink background
                                            border: "1px solid #E91E63", // Magenta border
                                            borderLeft: "5px solid #C2185B", // Dark magenta left border
                                            borderRadius: "6px",
                                            fontSize: "13px",
                                            color: "#880E4F",            // Dark magenta text
                                            textAlign: "justify",
                                            lineHeight: "1.5",
                                        }}
                                    >
                                        <span style={{ color: "#d32f2f", fontWeight: "bold" }}>Note:</span>{" "}
                                        A service titled <strong>"USC Number Confirmation"</strong> has been developed
                                        in <strong>CFMS</strong> to capture the Unique Service Connection (USC) details used by DDOs.
                                        Confirmation of USC details is mandatory for the implementation of the prepaid
                                        metering system. All DDOs are requested to complete the USC confirmation to
                                        avoid any inconvenience. If you have already completed the USC confirmation,
                                        kindly ignore this notification.
                                    </div>
                                </div>
                                {showErrorMsg &&
                                    <div className="row">
                                        <div className="col-12  col-sm-12 col-md-12 col-xl-12 col-lg-12">
                                            <div className="  alert alert-danger alert-dismissible fade show" role="alert">
                                                <strong>{errorMsg}</strong>
                                                <button type="button" onClick={() => setShowErrorMsg(false)} className="btn btn-close" data-dismiss="alert"></button>
                                            </div>
                                        </div>
                                    </div>
                                }

                            </form>

                        </div>
                        <br />

                    </HERBUI.Col>
                    <HERBUI.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} />
                    {/* <HERBUI.Row>
                        <HERBUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} />
                        <HERBUI.Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={8} >
                            <h5> <marquee behavior="scroll" direction="left" onMouseOver="this.stop();" onMouseOut="this.start();">
                                <span className="text-danger"> Dear Users, it is to inform that Nidhi Portal services will be temporarily unavailable for 2 days, from 15-JAN-2024 to 16-JAN-2024 due to system maintenance.
                                    Nidhi Portal services will be available on 17-JAN-2024. Kindly plan your services accordingly to this timeline.</span></marquee></h5>
                        </HERBUI.Col>
                        <HERBUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} />
                    </HERBUI.Row> */}
                </HERBUI.Row>
                <HERBUI.Modal show={show} onHide={handleClose} >
                    {/* <HERBUI.Modal.Header closeButton >
                        <HERBUI.Modal.Title>Information</HERBUI.Modal.Title>
                    </HERBUI.Modal.Header> */}
                    <HERBUI.Modal.Body className="position-relative">
                        <div className="">
                            <img src={close} alt="img" style={{ width: '30px', height: '30px', position: 'absolute', top: '-10px', right: '-10px' }}
                                onClick={() => setShow(false)}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                        setShow(false)
                                    }
                                }}
                            />
                        </div>
                        <HERBUI.Image src={login_popup} style={{ width: '100%', margin: '0px auto', display: 'block' }} />
                    </HERBUI.Modal.Body>
                </HERBUI.Modal>
            </FormikProvider>
            {/* <APGLI_PRESS_NOTE_MODAL show={apgliPressNoteShow} handleClose={handleCloseApgliPressNote} /> */}
        </>
    );
}
export default LoginPageDev;